import { validateKeys } from "../utilities";

export const isValidDate = date => {
  if (!date) return false;

  if (typeof date === "string") {
    const d = new Date(date);
    const t = d.getTime();
    return !isNaN(t);
  }

  // is special PC date object
  if (validateKeys({ $and: ["year", "month", "day"] }, date)) return true;

  if (typeof date === "object") {
    const isFn = typeof date.getMonth === "function";
    const monthIsNum = isFn && !isNaN(date.getMonth());
    return monthIsNum;
  }
  return false;
};
